import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

import { environment } from '../../../environments/environment';

export const SELECT_FETCH = 'SELECT_FETCH';

export const SELECT_FETCH_SUCCESS = 'SELECT_FETCH_SUCCESS';

export const SELECT_ERROR = 'SELECT_ERROR';

export const SelectActions = {
    fetch: ({http}) => {
        return {
            type: SELECT_FETCH,
            payload: {http}
        };
    },
};


export const SelectEpics = [
    // FETCH ALL OPTIONS
    ($action, store) => {
        return $action.ofType(SELECT_FETCH).mergeMap(action => {
            const {http} = action.payload;
            const criteriaActivated = {
                isOnlyActivated: true,
            };
            return Observable.forkJoin(
                // findAll sans paramètre remplacé par searchByCriteria avec parametre criteriaActivated
                http.get(environment.proxyUrl + '/discipline/searchByCriteria', {params: { 'params': JSON.stringify([criteriaActivated]) } }),
                http.get(environment.proxyUrl + '/professeur/findAll', {params: { 'params': JSON.stringify([]) } }),
                http.get(environment.proxyUrl + '/salle/searchByCriteria', {params: { 'params': JSON.stringify([criteriaActivated]) } }),
                http.get(environment.proxyUrl + '/niveau/findAllNiveaux', {params: { 'params': JSON.stringify([]) } }),
                http.get(environment.proxyUrl + '/niveau/findAllCycles', {params: { 'params': JSON.stringify([]) } }),
                http.get(environment.proxyUrl + '/reference/getReferenceObjects', {params: { 'params': JSON.stringify(['ref_type_discipline']) } }),
                http.get(environment.proxyUrl + '/reference/getReferenceObjects', {params: { 'params': JSON.stringify(['ref_type_paiement']) } }),
                http.get(environment.proxyUrl + '/cursus/findAllCursusActif', {params: { 'params': JSON.stringify([]) } }),
                http.get(environment.proxyUrl + '/reference/getReferenceObjects', { params: { 'params': JSON.stringify(['ref_annee_scolaire']) } }),
            ).map(([disciplines, professeurs, salles, niveaux, cycles, typesDisciplines, typesPaiements, cursus, anneesScolaires]) => {
                console.log({ disciplines, professeurs, salles, niveaux, cycles, typesDisciplines, typesPaiements, cursus, anneesScolaires});
                return {
                    type: SELECT_FETCH_SUCCESS,
                    payload: {
                        disciplines: (<any[]>disciplines).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                        professeurs: (<any[]>professeurs).map((option) => {
                            return {
                                value: option.id,
                                label: `${option.nom} ${option.prenom}`,
                            };
                        }),
                        salles: (<any[]>salles).map((option) => {
                            return {
                                value: option.id,
                                label: option.nom
                            };
                        }),
                        colors: (<any[]>salles).map((option) => {
                            return {
                                id: option.id,
                                value: '#' + parseInt(option.couleur).toString(16).padStart(6, '0')
                            };
                        }),
                        niveaux: (<any[]>niveaux).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                        cycles: (<any[]>cycles).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                        typesDisciplines: (<any[]>typesDisciplines).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                        typesPaiements: (<any[]>typesPaiements).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                        cursus: (<any[]>cursus).map((option) => {
                            return {
                                value: option.id,
                                label: option.nom,
                            };
                        }),
                        anneesScolaires: (<any[]>anneesScolaires).map((option) => {
                            return {
                                value: option.id,
                                label: option.libelle,
                            };
                        }),
                    }
                };
            });
        });
    }
];


const initialState = {
    loading: false,
    disciplines: null,
    professeurs: null,
    salles: null,
    colors: null,
    niveaux: null,
    cycles: null,
};

export const SelectReducer = (state = initialState, action: any) => {

    // console.log('SelectReducer', {action});

    switch (action.type) {

        case SELECT_FETCH:
            return {...state, loading: true};

        case SELECT_FETCH_SUCCESS:
            return {...state, loading: false, ...action.payload};

        case SELECT_ERROR:
            return {...state, loading: false};

        default:
            return state;
    }

}

export const isOneOfSelectOptionsNull = (selectOptions) => {
    let isNull = false;
    Object.keys(selectOptions).forEach(key => {
        if (selectOptions[key] == null) {
            isNull = true;
        }
    });
    return isNull;
};



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/resource/select.store.ts